/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Team_Not_EnteredInputs */

const th_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีมนี้ยังไม่ได้ลงทะเบียนในอีเวนต์นี้`)
};

const en_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That team is not entered in this event.`)
};

const ja_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このチームはこの大会に参加していません。`)
};

const zh_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这支球队未报名该赛事。`)
};

const es_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese equipo no está inscrito en este evento.`)
};

const pt_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse time não está inscrito neste evento.`)
};

const id_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim ini tidak terdaftar di acara tersebut.`)
};

const fr_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette équipe n’est pas inscrite à cet événement.`)
};

const tl_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nakarehistro sa event na iyon ang team na ito.`)
};

const vi_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội này chưa đăng ký sự kiện đó.`)
};

const ko_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 팀은 해당 이벤트에 등록되어 있지 않습니다.`)
};

const de_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Team ist nicht für dieses Event gemeldet.`)
};

const ru_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эта команда не заявлена на это событие.`)
};

const tr_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu takım o etkinliğe kayıtlı değil.`)
};

const it_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa squadra non è iscritta a quell'evento.`)
};

const pl_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta drużyna nie jest zgłoszona do tego wydarzenia.`)
};

const uk_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ця команда не заявлена на цю подію.`)
};

const hi_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह टीम उस आयोजन के लिए पंजीकृत नहीं है।`)
};

const ar_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا الفريق غير مسجَّل في تلك الفعالية.`)
};

const ms_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan ini tidak berdaftar untuk acara itu.`)
};

const bn_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই দল ওই আয়োজনে নিবন্ধিত নয়।`)
};

const zh_tw2_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這支球隊未報名該賽事。`)
};

const zh_hk2_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這支球隊未報名該賽事。`)
};

const ur_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ ٹیم اس ایونٹ کے لیے رجسٹرڈ نہیں۔`)
};

const fa_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این تیم در آن رویداد ثبت‌نام نکرده است.`)
};

const sw_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu hii haijasajiliwa kwenye tukio hilo.`)
};

const nl_err_team_not_entered = /** @type {(inputs: Err_Team_Not_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit team is niet ingeschreven voor dat evenement.`)
};

/**
* | output |
* | --- |
* | "That team is not entered in this event." |
*
* @param {Err_Team_Not_EnteredInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_team_not_entered = /** @type {((inputs?: Err_Team_Not_EnteredInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Team_Not_EnteredInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_team_not_entered(inputs)
	if (locale === "ja") return ja_err_team_not_entered(inputs)
	if (locale === "zh") return zh_err_team_not_entered(inputs)
	if (locale === "es") return es_err_team_not_entered(inputs)
	if (locale === "pt") return pt_err_team_not_entered(inputs)
	if (locale === "id") return id_err_team_not_entered(inputs)
	if (locale === "fr") return fr_err_team_not_entered(inputs)
	if (locale === "tl") return tl_err_team_not_entered(inputs)
	if (locale === "vi") return vi_err_team_not_entered(inputs)
	if (locale === "ko") return ko_err_team_not_entered(inputs)
	if (locale === "de") return de_err_team_not_entered(inputs)
	if (locale === "ru") return ru_err_team_not_entered(inputs)
	if (locale === "tr") return tr_err_team_not_entered(inputs)
	if (locale === "it") return it_err_team_not_entered(inputs)
	if (locale === "pl") return pl_err_team_not_entered(inputs)
	if (locale === "uk") return uk_err_team_not_entered(inputs)
	if (locale === "hi") return hi_err_team_not_entered(inputs)
	if (locale === "ar") return ar_err_team_not_entered(inputs)
	if (locale === "ms") return ms_err_team_not_entered(inputs)
	if (locale === "bn") return bn_err_team_not_entered(inputs)
	if (locale === "zh-TW") return zh_tw2_err_team_not_entered(inputs)
	if (locale === "zh-HK") return zh_hk2_err_team_not_entered(inputs)
	if (locale === "ur") return ur_err_team_not_entered(inputs)
	if (locale === "fa") return fa_err_team_not_entered(inputs)
	if (locale === "sw") return sw_err_team_not_entered(inputs)
	if (locale === "nl") return nl_err_team_not_entered(inputs)
	return en_err_team_not_entered(inputs)
});